<template>
  <div v-if="rules.length > 0">
    <div v-for="rule in rules">
      <div class="alert alert-danger" v-if="rule.warningLevel == 3">
        {{rule.description}}
      </div>
      <div class="alert alert-warning" v-if="rule.warningLevel == 2">
        {{rule.description}}
      </div>
      <div class="alert alert-success" v-if="rule.warningLevel == 1">
        {{rule.description}}
      </div>
    </div>
  </div>
</template>

<script>
  import axios from "axios";

  export default {
    name: "rules",
    data() {
      return {
        rules: [],
      };
    },
    props: ['date'],
    watch: {
      date: function (newVal, oldVal) { // watch it
        this.updateRules(newVal);
      }
    },
    mounted() {
      this.updateRules(this.date);
    },
    methods: {
      updateRules: function (date) {
        axios({ method: "GET", url: process.env.VUE_APP_API_PATH+"rules/Progress?date=" + date }).then(result => {
          this.rules = result.data;
        }, error => {
          console.error(error);
          if (error.response.status == 401) {
            this.$router.push("/");
          }
        });
      }
    }
  };


</script>
